<template>
  <div class="ChiefList">
    <rj-tabs v-model="tabsActive">
      <rj-tab-pane name="1" label="全部订单">
        <all-list />
      </rj-tab-pane>
      <rj-tab-pane name="2">
        <span slot="label">待提交(<span class="tabNameTip">{{ nums.submit }}</span>)</span>
        <stay-submit-list />
      </rj-tab-pane>
      <rj-tab-pane name="3">
        <span slot="label">待盖章(<span class="tabNameTip">{{ nums.seal }}</span>)</span>
        <stay-seal-list />
      </rj-tab-pane>
      <rj-tab-pane name="4">
        <span slot="label">待付款(<span class="tabNameTip">{{ nums.pay }}</span>)</span>
        <stay-pay-for-list />
      </rj-tab-pane>
      <rj-tab-pane name="5">
        <span slot="label">待收货(<span class="tabNameTip">{{ nums.Rec }}</span>)</span>
        <stay-receive-list />
      </rj-tab-pane>
      <rj-tab-pane name="6">
        <span slot="label">已收货(<span class="tabNameTip">{{ nums.Arec }}</span>)</span>
        <already-receive-list />
      </rj-tab-pane>
      <!-- v-if="$store.state.needShow" -->
      <rj-tab-pane name="7">
        <span slot="label">已申请分批发货(<span class="tabNameTip">{{ nums.part }}</span>)</span>
        <applyBatch />
      </rj-tab-pane>
      <rj-tab-pane name="9">
        <span slot="label">待付款分批发货(<span class="tabNameTip">{{ nums.wait }}</span>)</span>
        <waitBatch />
      </rj-tab-pane>
      <rj-tab-pane name="8">
        <span slot="label">待处理分批发货(<span class="tabNameTip">{{ nums.reject }}</span>)</span>
        <rejectApplyBatch />
      </rj-tab-pane>
      <rj-tab-pane v-if="isStrategyList" name="10">
        <span slot="label">待处理战略发货(<span class="tabNameTip">{{ nums.strategy }}</span>)</span>
        <strategyList />
      </rj-tab-pane>
    </rj-tabs>
  </div>
</template>
<script type="es6">
import tabs from '@/components/Tabs/tabs';
import tabPane from '@/components/Tabs/tabPane';
import allList from './allList';
import staySubmitList from './staySubmitList';
import staySealList from './staySealList';
import alreadyReceiveList from './alreadyReceiveList';
import applyBatch from './applyBatch';
import rejectApplyBatch from './rejectApplyBatch';
import waitBatch from './waitBatch';
import stayReceiveList from './stayReceiveList';
import stayPayForList from './stayPayForList';
import { selectContractSort, getPartialWhiteList } from '../../../API/index';
import { mapActions } from 'vuex';
import eventBus from '@/libs/eventBus.js';
// 待处理战略发货
import strategyList from './strategy-list/index.vue';

export default {
  data () {
    return {
      nums: {
        submit: 0,
        seal: 0,
        pay: 0,
        Arec: 0,
        Rec: 0,
        part: 0,
        reject: 0,
        strategy: 0
      },
      needShow: false
    };
  },
  components: {
    'rj-tab-pane': tabPane,
    'rj-tabs': tabs,
    allList,
    staySubmitList,
    staySealList,
    stayPayForList,
    alreadyReceiveList,
    stayReceiveList,
    applyBatch,
    rejectApplyBatch,
    waitBatch,
    strategyList
  },
  computed: {
    tabsActive: {
      get () {
        return this.$store.state.pagesTemporary.ChiefContractListTabActive;
      },
      set (val) {
        this.$store.commit('pagesTemporary/SETChiefContractListTabActive', val);
      }
    },

    // 判断是否只有【待处理战略发货】权限
    isStrategyList () {
      return this.$store.state.user?.perssimionCodeList.some(i => i === 'strategicPartialShipmentContractsList');
    }
  },
  methods: {
    ...mapActions('enumeration', [
      'initOrderType',
      'initSupplyUnit'
    ]),
    selectContractSort () {
      // 各状态合同数量
      selectContractSort().then((res) => {
        let json = res.data;
        if (json.status === '200') {
          json.data.forEach((item) => {
            if (item.statusCode === 1) {
              this.nums.submit = item.counts;
              return;
            }
            if (item.statusCode === 2) {
              this.nums.seal = item.counts;
            }
            if (item.statusCode === 3) {
              this.nums.pay = item.counts;
            }
            if (item.statusCode === 5) {
              this.nums.Rec = item.counts;
            }
            if (item.statusCode === 6) {
              this.nums.Arec = item.counts;
            }
            if (item.statusCode === 7) {
              this.nums.part = item.counts;
            }
            if (item.statusCode === 8) {
              this.nums.reject = item.counts;
            }
            if (item.statusCode === 9) {
              this.nums.wait = item.counts;
            }
            if (item.statusCode === 10) {
              this.nums.strategy = item.counts;
            }
          });
        }
      }).catch(() => {

      });
    },
    // 获取白名单
    getWhite () {
      // 各状态合同数量
      getPartialWhiteList().then((res) => {
        res.data.data.forEach(item => {
          if (item === this.$store.state.user.userId) {
            this.$store.commit('showWhite', true);
          }
        });
      }).catch(() => {

      });
    }
  },
  mounted () {
    this.selectContractSort();
    this.getWhite();
    this.initOrderType();
    this.initSupplyUnit();
    // 改变已收货列表数量
    eventBus.$on('changescom', () => {
      this.selectContractSort();
    });
  }
};
</script>
<style lang="scss" >
  @import "../../../style/var";
  .ChiefList{
  .rj-tabs .rj-tabs-names .rj-tab-name{
        padding: 10px 10px;
  }
  }
  .tabNameTip{
    color: $--color-primary-light-1;
  }
</style>
